window.addEventListener("load", function () {
	const Loader = document.querySelector(".loader");
	Loader.classList.add("hidden");
});

AOS.init({
    once: true,
});

var swiper = new Swiper('.mySwiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 1,
        },
        1024: {
            slidesPerView: 1,
        },
    },
});